<div class="cerrix-textarea-group-header">
    <div class="label-container">
        <cerrix-label [for]="name"><ng-content></ng-content></cerrix-label>
        @if (infoText) {
            <cerrix-instructions-icon
                class="textarea-instructions-icon"
                [instructionText]="infoText"
                [showText]="false"
            ></cerrix-instructions-icon>
        }
    </div>
    <mat-icon class="expand-icon" svgIcon="expand" (click)="openTextareaDialog()"></mat-icon>
</div>
<cerrix-textarea
    validationErrors
    [validationMaxLength]="maxLength"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readOnly]="readOnly"
    [resize]="resize"
    [rows]="rows"
    [(value)]="value"
    (valueChange)="valueChange.emit(value)"
></cerrix-textarea>
<cerrix-textarea-dialog
    #textareaDialog
    [name]="name + '-dialog'"
    [dataUiid]="name + '-dialog'"
    [title]="textareaDialogTitle"
    [value]="value"
    (cancel)="closeTextareaDialog()"
    (confirm)="closeTextareaDialog($event)"
></cerrix-textarea-dialog>
